// Data passed as props to the root component
export const mockRootProps = {
  accountInfo: {
    businessName: "E2E Digitech Pvt Ltd",
    contact: "+91 1234567890", 
    website: "www.e2edigitechpvtltd.com",
    address: "23 Maplewood Lane, IL 62704, USA",
    name: "John Doe",
    email: "john@e2edigitechpvtltd.com",
    altContact: "+91 9876543210"
  },
  designs: [
    {
      id: 1,
      title: "Festival",
      imageUrl: "/images/festival-diwali.png"
    },
    {
      id: 5,
      title: "Special Day",
      imageUrl: "/images/special-day-christmas.jpg"
    },
    {
      id: 6,
      title: "Offers & Products",
      imageUrl: "/images/offer-products.png"
    }
  ]
};

// Export mockDesignTemplates for DesignTemplateGrid
export const mockDesignTemplates = mockRootProps.designs;

// Export mockFooterLinks for FooterSection
export const mockFooterLinks = [
  { label: "About Us", href: "/about" },
  { label: "Services", href: "/services" },
  { label: "Contact", href: "/contact" },
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Terms of Service", href: "/terms" }
];